import React from 'react';
import { motion } from 'framer-motion';
import { Check, X } from 'lucide-react';
export function WhoItsFor() {
  return <section className="w-full py-20 md:py-32 px-6 bg-navy relative" data-id="element-169">
      <div className="max-w-5xl mx-auto" data-id="element-170">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="font-serif text-3xl md:text-5xl font-bold text-cream mb-16 text-center" data-id="element-171">
          PARA QUIÉN ES
        </motion.h2>

        <div className="grid md:grid-cols-2 gap-8 md:gap-16" data-id="element-172">
          {/* For You */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="bg-navy-light/30 p-8 rounded-xl border border-green-900/30" data-id="element-173">
            <h3 className="text-xl font-bold text-green-400 mb-6 flex items-center" data-id="element-174">
              <Check className="w-6 h-6 mr-2" data-id="element-175" />
              ESTO ES PARA TI SI:
            </h3>
            <ul className="space-y-4" data-id="element-176">
              {['Te despiertas 3–4AM varias noches por semana', 'Te cuesta volver a dormir', 'Te sientes agotada al día siguiente', 'Quieres algo simple, imprimible, y en español'].map((item, i) => <li key={i} className="flex items-start text-cream-muted text-lg" data-id="element-177">
                  <Check className="w-5 h-5 text-green-500 mr-3 mt-1 flex-shrink-0" data-id="element-178" />
                  <span data-id="element-179">{item}</span>
                </li>)}
            </ul>
          </motion.div>

          {/* Not For You */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="bg-navy-light/30 p-8 rounded-xl border border-red-900/30" data-id="element-180">
            <h3 className="text-xl font-bold text-red-400 mb-6 flex items-center" data-id="element-181">
              <X className="w-6 h-6 mr-2" data-id="element-182" />
              ESTO NO ES PARA TI SI:
            </h3>
            <ul className="space-y-4" data-id="element-183">
              {['Buscas diagnóstico o tratamiento médico', 'Quieres una promesa garantizada', 'No estás dispuesta a dejar el celular fuera de la cama'].map((item, i) => <li key={i} className="flex items-start text-cream-muted text-lg" data-id="element-184">
                  <X className="w-5 h-5 text-red-500 mr-3 mt-1 flex-shrink-0" data-id="element-185" />
                  <span data-id="element-186">{item}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}